import {IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar} from '@ionic/react';
import React from 'react';
import {connect} from 'react-redux';
import {RouteComponentProps} from 'react-router';
import {RootState} from '../store';
import "./RulesPage.css"
import DeviceTypeUtils from "../utils/DeviceType.utils";
import Constants from "../config/Contants";
import {PluginListenerHandle, Plugins} from "@capacitor/core";

type RulesPageProps = RouteComponentProps<{ contestId: string, tab: string }> & typeof mapDispatchToProps;
type State = {}

class RulesPage extends React.Component<RulesPageProps, State> {
  private backButtonHandle ?: PluginListenerHandle;

  constructor(props: RulesPageProps) {
    super(props);
    this.state = {}
  }

  componentDidMount(): void {
    this.backButtonHandle = Plugins.App.addListener('backButton', () => this.props.history.push("/"));
  }

  componentWillUnmount(): void {
    this.backButtonHandle!.remove()
  }

  render() {
    return (
      <>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton/>
            </IonButtons>
            <IonTitle>LRV digitaal - Reglement</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          <div className={"rules-page-content"}>
            <a className="download" href="https://www.lrv.be/userfiles/file/bundels/2310-wedstrijdreglement-oktober-2018-werkversie.pdf" target="_blank">Download reglement.</a>
          </div>
        </IonContent>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RulesPage);
